import { Button, Checkbox, FormControlLabel } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';
import { IDomainUserInDTO } from '../../../repository/jago/model/input/IDomainUserInDTO';
import ReduxLanguage from '../../ReduxLanguage';
import { PersonOutline } from '@material-ui/icons';

export interface UserDeleteFormState {
  anonymizeAllEvents: boolean;
  deleteAllStandardDevices: boolean;
};

export interface UserDeleteFormProps {
  onConfirmDeleteUser: (anonymizeAllEvents: boolean, deleteAllStandardDevices: boolean) => void;
  user: IDomainUserInDTO;
};

export default class UserDeleteForm extends React.Component<UserDeleteFormProps, UserDeleteFormState> {
  
  constructor(props: UserDeleteFormProps) {
    super(props);
    this.state = {
      anonymizeAllEvents: false,
      deleteAllStandardDevices: false,
    };
  }
  onSetValue(field: keyof UserDeleteFormState, value: boolean) {
    this.setState({ [field]: value });
  }

  onSubmitForm() {
    const { anonymizeAllEvents, deleteAllStandardDevices } = this.state;
    this.props.onConfirmDeleteUser(anonymizeAllEvents, deleteAllStandardDevices);
  }

  render(): React.ReactNode {
    const { user } = this.props;
    const { anonymizeAllEvents, deleteAllStandardDevices } = this.state;
    return (
      <div style={{ flexDirection: 'column', display: 'flex' }}>
        <WarningIcon style={{ color: 'orange', alignSelf: 'center', fontSize: 50 }} />
        <h3 style={{ marginTop: 0, fontWeight: 'bold', textAlign: 'center', fontSize: 20 }}>{<ReduxLanguage languageKey="forms.warning" />}</h3>
        <div style={{ marginTop: 20, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
          <PersonOutline style={{ fontSize: 22 }} />
          <h4 style={{ fontSize: 18, fontWeight: 'bold' }}>{user.firstname} {user.lastname} ({user.email})</h4>
        </div>
        <h4 style={{ marginTop: 25, fontSize: 16 }}>{<ReduxLanguage languageKey="vars.deleteUserConfirm" />}</h4>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
        <FormControlLabel
          control={<Checkbox checked={anonymizeAllEvents} onChange={(e, checked) => this.onSetValue('anonymizeAllEvents', checked)} name="anonymizeAllEvents" />}
          label={<h4 style={{ fontSize: 15 }}><ReduxLanguage languageKey={'forms.anonymizeAllEvents'} /></h4>}
          style={{ marginTop: 10 }}
        />
        <FormControlLabel
          control={<Checkbox checked={deleteAllStandardDevices} onChange={(e, checked) => this.onSetValue('deleteAllStandardDevices', checked)} name="deleteAllStandardDevices" />}
          label={<h4 style={{ fontSize: 15 }}><ReduxLanguage languageKey={'forms.deleteAllStandardDevices'} /></h4>}
          style={{ marginTop: 10 }}
        />
      </div>
      <Button
        variant="contained"
        style={{ width: '100%', backgroundColor: '#5AC0B1', color: 'white', marginTop: 30, fontWeight: 'bold'  }}
        onClick={() => this.onSubmitForm()}
      >
        <ReduxLanguage languageKey="forms.confirm" />
      </Button>
      </div>
    );
  }
}
